import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose, DialogDescription } from "@/components/ui/dialog"
import { ScrollArea } from "@/components/ui/scroll-area"
import { useLocation, useNavigate } from "react-router"
import { HashSidebarItemType } from "../navigation/HashSidebar/HashSidebarItem"
import HashSidebar from "../navigation/HashSidebar"

type SideModalProps = {
  title: string // Título do modal
  baseHash: string // Base do hash (ex: "settings", "tools")
  //   sidebarContent: (currentSection: string) => React.ReactNode // Sidebar recebe a seção atual
  content: Record<string, React.ReactNode> // Mapeamento de seções para conteúdos
  defaultSection: string // Seção padrão ao abrir (ex: "members")

  items: HashSidebarItemType[]
}

export function SideModal(props: SideModalProps) {
  const location = useLocation()
  const navigate = useNavigate()
  const hash = location.hash
  const isModalOpen = hash.startsWith(`#${props.baseHash}`)
  const currentSection = hash.split("/")?.[1]
  const currentSectionId = hash.split("/")?.[2]

  //   const [isOpen, setIsOpen] = useState(isModalOpen)

  // Lê o hash atual

  //   const openModal = () => {
  //     setIsOpen(true)
  //     navigate(`${location.pathname}${location.search}#${props.baseHash}/${props.defaultSection}`, {
  //       replace: true,
  //     })
  //   }

  const closeModal = () => {
    navigate(`${location.pathname}${location.search}`, { replace: true })
  }

  //   useEffect(() => {
  //     console.log("isModalOpen", isModalOpen)
  //     if (isModalOpen) {
  //       setIsOpen(true)
  //     } else {
  //       //   closeModal()
  //     }
  //   }, [isModalOpen])

  return (
    <>
      <Dialog
        open={isModalOpen}
        onOpenChange={(open) => {
          if (!open) {
            closeModal()
          }
        }}
      >
        <DialogContent className="w-full p-0 md:max-w-5xl bg-background gap-0 [&_.g-close-btn]:top-5.5">
          <DialogHeader className="hidden">
            <DialogTitle className="text-xl font-medium">{props.title}</DialogTitle>
            <DialogDescription />
          </DialogHeader>
          <div className="flex h-[600px] flex-1 w-full">
            <HashSidebar
              title={props.title}
              items={props.items}
              currentSection={currentSection}
              baseHash={props.baseHash}
              collapsed={!!currentSectionId}
            />
            {/* {props.sidebarContent(currentSection)} */}
            {/* <ScrollArea className="flex-1"> */}
              {props.content[currentSection] || props.content[props.defaultSection] || <div>Section not found</div>}
            {/* </ScrollArea> */}
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
